import { Component, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { ApiUrlHelper } from 'src/app/common/apiUrlHelper';
import { CommonConstant } from 'src/app/constants/common-constant';
import { CollegeConstant, StudentLableConstant } from 'src/app/constants/label-constants';
import { CommonService } from 'src/app/services/common/common.service';
import { DirtycheckDialogboxComponent } from '../../dirtycheck-dialogbox/dirtycheck-dialogbox.component';
import { ReplaySubject, Subject, takeUntil } from 'rxjs';
import { MatSelect } from '@angular/material/select';
import { collegeErrorPageMessage, commonErrorMessage, studentErrorPageMessage } from 'src/app/constants/error-message-constant';
import { SaveStudentConfirmationDialogComponent } from '../../save-student-confirmation-dialog/save-student-confirmation-dialog.component';
interface colleges {
  id: any;
  value: string;
}
interface collegeBatch {
  id: any;
  value: string;
}
@Component({
  selector: 'app-student-add',
  templateUrl: './student-add.component.html',
  styleUrls: ['./student-add.component.scss']
})
export class StudentAddComponent {
  StudentForm: FormGroup = this.formBuilder.group({});
  studentId: number = 0;
  modalButton: boolean = false;
  CommonConstant: any = [];
  StudentLableConstant: any = [];
  CollegeBatchList: any = [];
  CollegeList: any = [];
  collegeId: number = 0;
  collegeBatchId: number = 0;
  flag: boolean = false;
  CollegeLabelConstant: any = [];
  errorMessage: any = [];
  commonErrorMessage: any = [];
  collegeErrorMessage: any = [];
  protected AllCollegelist: colleges[] = this.CollegeList;
  protected AllCollegeBatchlist: collegeBatch[] = this.CollegeBatchList;
  public FilterCtrl: FormControl = new FormControl();
  public Ctrl: FormControl = new FormControl();
  public filteredData: ReplaySubject<any> = new ReplaySubject();
  public filteredBatchData: ReplaySubject<any> = new ReplaySubject();

  @ViewChild('singleSelect', { static: true })
  singleSelect!: MatSelect;
  protected _onDestroy = new Subject();

  ngOnDestroy() {
    this._onDestroy.next(1);
    this._onDestroy.complete();
  }

  protected filterdata() {
    if (!this.AllCollegelist) {
      return;
    }
    let search = this.FilterCtrl.value;
    if (!search) {
      this.filteredData.next(this.AllCollegelist.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredData.next(
      this.AllCollegelist.filter(data => data.value.toLowerCase().indexOf(search) > -1)
    );
  }

  protected filterBatchdata() {
    debugger;
    if (!this.AllCollegeBatchlist) {
      return;
    }
    let search = this.Ctrl.value;
    if (!search) {
      this.filteredBatchData.next(this.AllCollegeBatchlist.slice());
      return;
    } else {
      search = search.toLowerCase();
    }
    this.filteredBatchData.next(
      this.AllCollegeBatchlist.filter(data => data.value.toLowerCase().indexOf(search) > -1)
    );
  }

  constructor(
    private formBuilder: FormBuilder,
    private CommonService: CommonService,
    private toster: ToastrService,
    private apiUrl: ApiUrlHelper,
    private spinner: NgxSpinnerService,
    public modalService: NgbActiveModal,
    public ModalService: NgbModal,
  ) { }

  ngOnInit(): void {
    this.filteredData.next(this.AllCollegelist.slice());
    this.FilterCtrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterdata();
      });
    this.filteredBatchData.next(this.AllCollegeBatchlist.slice());
    this.Ctrl.valueChanges
      .pipe(takeUntil(this._onDestroy))
      .subscribe(() => {
        this.filterBatchdata();
      });
    this.spinner.show();
    this.CommonConstant = CommonConstant;
    this.StudentLableConstant = StudentLableConstant;
    this.CollegeLabelConstant = CollegeConstant;
    this.errorMessage = studentErrorPageMessage;
    this.commonErrorMessage = commonErrorMessage;
    this.collegeErrorMessage = collegeErrorPageMessage;
    this.onInitStudentForm();
    this.getCollegeList();
  }
  keyPressNumbers(event) {
    var charCode = (event.which) ? event.which : event.keyCode;
    if ((charCode < 48 || charCode > 57)) {
      event.preventDefault();
      return false;
    } else {
      return true;
    }
  }

  getCollegeList() {
    const apiUrl = this.apiUrl.apiUrl.college.GetCollegeListForDropDown;
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        if (data && data.data && data.data.length > 0) {
          for (let i = 0; i < data.data.length; i++) {
            this.CollegeList.push({ 'id': data.data[i].collegeId, 'value': data.data[i].collegeName })
          }
          this.filterdata();
        }
        this.spinner.hide();

        this.flag = true;
      },
      error: (err) => {
        this.toster.error(err.message);
      }
    });
  }

  onChangeCollege(e: any) {
    this.spinner.show();
    this.CollegeBatchList = [];
    this.collegeId = e.value;
    const apiUrl = this.apiUrl.apiUrl.collageBatch.GetCollegeBatchListByCollegeIdAndCompanyId.replace("{id}", this.collegeId.toString());
    this.CommonService.doGet(apiUrl).pipe().subscribe({
      next: (data) => {
        if (data && data.data && data.data.length > 0) {
          for (let i = 0; i < data.data.length; i++) {
            this.CollegeBatchList.push({ 'id': data.data[i].collegeBatchId, 'value': data.data[i].batchName })
          }
        }
        this.AllCollegeBatchlist = this.CollegeBatchList;
        this.filterBatchdata();
        this.spinner.hide();
      },
      error: (err) => {
        this.toster.error(err.message);
      }
    });
  }

  onChangeBatch(e: any) {
    this.collegeBatchId = e.value;
  }

  onInitStudentForm() {
    this.StudentForm = this.formBuilder.group({
      StudentId: [0],
      StudentName: ['', [Validators.required, Validators.maxLength(100)]],
      CollegeId: ['', [Validators.required]],
      CollegeBatchId: ['', [Validators.required]],
      EmailId: ['', [Validators.required, Validators.pattern(/^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/)]],
      MobileNo: ['', [Validators.required, Validators.pattern(/^[6-9][0-9]{9}$/)]],
    });
  }

  get studentFormControl() {
    return this.StudentForm.controls;
  }

  saveStudent() {
    debugger;
    const modalRef = this.ModalService.open(SaveStudentConfirmationDialogComponent, { centered: true, backdrop: 'static', keyboard: false });
    modalRef.result.then((result) => {
      if (result === 'save') {
        debugger;
        this.modalButton = true;
        if (!this.StudentForm.valid) {
          return;
        }
        this.spinner.show();
        const objData: any = {
          StudentId: 0,
          StudentName: this.StudentForm.value.StudentName,
          CollegeId: Number(this.collegeId),
          CollegeBatchId: Number(this.collegeBatchId),
          EmailId: this.StudentForm.value.EmailId.toLowerCase().trim(),
          MobileNo: this.StudentForm.value.MobileNo
        }
        const apiUrl = this.apiUrl.apiUrl.student.SaveStudent;
        this.CommonService.doPost(apiUrl, objData).pipe().subscribe({
          next: (data) => {
            if (data.success) {
              this.modalButton = false;
              this.spinner.hide();
              this.modalService.close('save');
              this.toster.success(data.message);
            }
            else {
              this.modalButton = false;
              this.spinner.hide();
              this.toster.error(data.message);
            }
          },
          error: (er) => {
            this.toster.error(er.message)
          }
        });
      }
    }).catch(() => { });

  }

  onCancel() {
    if (this.StudentForm.dirty) {
      const modalRef = this.ModalService.open(DirtycheckDialogboxComponent, { centered: true, backdrop: 'static', keyboard: false });
      modalRef.componentInstance.StudentForm = this.StudentForm;
    }
    else {
      this.modalService.close();
    }
  }
}
